import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import BrandMark from "./BrandMark";

const links = [
  ["features", "Features"],
  ["showcase", "Examples"],
  ["how-it-works", "How it works"],
  ["pricing", "Pricing"],
  ["faq", "FAQ"],
];

export default function Navbar({ onGetStarted }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header data-testid="navbar-container" className={`site-nav ${scrolled ? "is-scrolled" : ""}`}>
      <div className="page-width nav-inner">
        <a data-testid="nav-home-link" className="nav-brand" href="#home" onClick={closeMenu}>
          <BrandMark compact />
        </a>
        <nav className={`nav-links ${menuOpen ? "is-open" : ""}`} aria-label="Main navigation">
          {links.map(([id, label], index) => (
            <a data-testid={`nav-${id}-link`} href={`#${id}`} onClick={closeMenu} key={id}>{label}<span>0{index + 1}</span></a>
          ))}
        </nav>
        <button data-testid="nav-get-started-btn" className="nav-cta" onClick={onGetStarted}>GET STARTED <ArrowUpRight size={15} /></button>
        <button data-testid="nav-mobile-menu-toggle" className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen} aria-label={menuOpen ? "Close menu" : "Open menu"}>{menuOpen ? <X size={22} /> : <Menu size={22} />}</button>
      </div>
    </header>
  );
}
